
import Link from "next/link";
import User from "./Offcanvas/User";

const UserMenu = ({ userType }) => {
  return (
    <>
      <li className="account-access rbt-user-wrapper d-none d-xl-block">
        <Link href="#">
          <i className="feather-user"></i> {userType}
        </Link>
        <User />
      </li>
      <li className="access-icon rbt-user-wrapper d-block d-xl-none">
        <Link className="rbt-round-btn" href="#">
          <i className="feather-user"></i>
        </Link>
        <User />
      </li>
    </>
  );
};

export default UserMenu;